/**
 * @generated SignedSource<<928ca86b5275748d99a683ed02be5a57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileScreenEmployee_employee$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployeeEmployeeName_employee" | "ProfileScreenEmployeeProfileImage_employee" | "ProfileScreenEmployeeTodaysShifts_employee">;
  readonly " $fragmentType": "ProfileScreenEmployee_employee";
};
export type ProfileScreenEmployee_employee$key = {
  readonly " $data"?: ProfileScreenEmployee_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployee_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileScreenEmployee_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileScreenEmployeeProfileImage_employee"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileScreenEmployeeEmployeeName_employee"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileScreenEmployeeTodaysShifts_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "e2da40cdbc80bb37cbf74d7fbee08a5f";

export default node;
